<template>
  <div class="d d_xm">
    <headers :goBack="goBack" />
    <template v-if="list">
      <form6 :list="list" />
      <div-footer :status="status" :isShow="true" :formId="formId" :id="id" />
    </template>
    <template v-else>
      <van-empty description="暂无相关数据" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getsubmitData } from "@/service/form";
import { format, formatIdByTxt } from "@/common/js";
import { sponsorTypes, activeThemes, activeTypes } from "@/common/js/field";
import divFooter from "@/components/Footer";
import headers from "@/components/Header";
import form6 from "@/components/form/Form6";
export default {
  name: "detailForm6",
  components: { divFooter, headers, form6 },
  beforeRouteEnter(to, from, next) {
    console.log(to.path, from.path);
    next((vm) => {
      // vm 是当前组件的实例
      const zUrl = ["/info/wtg", "info/ytj"];
      if (zUrl.indexOf(from.path) !== -1) {
        vm.isShowTips = true;
      }
    });
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      list: [],
      id: 0,
      formId: 0,
      status: 0,
    });

    onMounted(async () => {
      getInfo();
    });
    const getInfo = async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      if (code == 10000 && data) {
        state.status = data.status;
        let newObj = { form: {} };
        state.formId = data.formId - 1;
        state.id = data.id;
        for (const i of data.list) {
          if (i.fieldCode == "items") {
            let value = i.value;
            // 处理select、date 回显
            for (let c = 0; c < value.length; c++) {
              value[c].activeThemesTxt = formatIdByTxt(
                activeThemes,
                value[c].activeTheme
              );
              value[c].activeType = formatIdByTxt(activeTypes, value[c].activeType);
              value[c].sponsorTypeTxt = formatIdByTxt(sponsorTypes, value[c].sponsorType);
              value[c].date = `${value[c].startDay}至${value[c].endDay}`;
            }
            newObj.form[i.fieldCode] = value;
          }
        }
        state.list = newObj.form;
      }
    };

    const goBack = () => {
      router.go(-1);
    };
    return {
      ...toRefs(state),
      format,
      goBack,
    };
  },
};
</script>
<style lang="less" scoped></style>
